export const trackingTimeZone = 'Europe/Zagreb';

export function parseTimestamp(value: unknown): number | null {
    if (typeof value !== 'string' && typeof value !== 'number') return null;
    // The API sends UTC, including ISO date-times without a timezone suffix.
    const utcValue = typeof value === 'string'
        && /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/.test(value.trim())
        ? `${value.trim().replace(' ', 'T')}Z` : value;
    // Numeric Unix timestamps may be expressed in seconds or milliseconds.
    const timestamp = typeof utcValue === 'number'
        ? new Date(utcValue < 1e12 ? utcValue * 1000 : utcValue).getTime()
        : Date.parse(utcValue);
    return Number.isFinite(timestamp) ? timestamp : null;
}
